// extracted by mini-css-extract-plugin
export var addToCartButton = "_qu-b";
export var arrowButtonContainer = "_qu-9";
export var arrowButtonIcon = "_qu-a";
export var carouselArrowButton = "_qu-6";
export var carouselElementContainer = "_qu-1";
export var left = "_qu-7";
export var productDisplayCarouselContainer = "_qu-0";
export var productTileContainer = "_qu-2";
export var productTileImage = "_qu-4";
export var productTileImageContainer = "_qu-3";
export var productTileTitle = "_qu-5";
export var right = "_qu-8";
export var sliderOverflow = "_qu-c";